import { render, staticRenderFns } from "./ExpenseChart.vue?vue&type=template&id=ba4bf026&"
import script from "./ExpenseChart.vue?vue&type=script&lang=js&"
export * from "./ExpenseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports